import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const VideoIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('VideoIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 17"
    data-track-tag={dataTrackTag}
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.622 6.778H5.616m5.03 3.464 3.393 1.671c.351.214.72.088.71-.359l-.023-5.906c-.03-.485-.316-.618-.737-.393l-3.353 1.523m-7.744 6.465h6.097c.907 0 1.642-.726 1.642-1.621l.014-2.08-.014-4.164c0-.895-.735-1.621-1.642-1.621H2.892c-.907 0-1.642.726-1.642 1.621v6.244c0 .895.735 1.621 1.642 1.621"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
VideoIcon.id = 'VideoIcon';
VideoIcon.displayName = 'VideoIcon';
export default VideoIcon;
